import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SolicitudService } from '../../../../../../services/solicitud.service';
import { GrupoService } from "../../../../../../services/grupo.service";

@Component({
  selector: 'app-documentoalta',
  templateUrl: './documentoalta.component.html',
  styleUrls: ['./documentoalta.component.css'],
  providers: [SolicitudService, GrupoService]
})
export class DocumentoaltaComponent implements OnInit {
  public identity;
  public token;
  public file;

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private _grupoService: GrupoService,
    private _solicitudService: SolicitudService
  ) {
    this.identity = this._grupoService.getIdentity();
    this.token = this._grupoService.getToken();
  }

  ngOnInit() {
    this._route.params.subscribe(params => {
      // convertir a entero
      let id = +params['solicitud_id'];

      this.getImage(id);
    });
  }

  getImage(solicitud_id) {
    this._solicitudService.getImage(this.token, solicitud_id).subscribe(
      response => {
        // Obtener el token
        this.file = URL.createObjectURL(response);
        location.href = this.file;
      },
      error => {
        if (error["status"] == 401) {
          this._router.navigate(["logout/1"]);
        } else {
          alert('El archivo no se encuentra adjunto en el sistema');
          window.close();
        }
      }
    );
  }

}
